var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsd = function SvgUsd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#059669",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usd_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.102 10.938c0-.52.4-.938.9-.938.498 0 .9.418.9.938V12.5h2.1c.663 0 1.2.559 1.2 1.25s-.537 1.25-1.2 1.25h-4.31c-.933 0-1.69.79-1.69 1.762 0 .879.618 1.62 1.45 1.746l3.436.512c2.017.3 3.514 2.097 3.514 4.218 0 2.356-1.834 4.262-4.092 4.262h-.408v1.563c0 .519-.402.937-.9.937-.5 0-.9-.418-.9-.938V27.5h-2.7c-.664 0-1.2-.559-1.2-1.25s.536-1.25 1.2-1.25h4.908c.934 0 1.692-.79 1.692-1.762 0-.879-.62-1.62-1.452-1.746l-3.435-.512c-2.017-.296-3.513-2.097-3.513-4.218 0-2.352 1.833-4.262 4.09-4.262h.41v-1.563Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "usd_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 10h12v20H14z"
  })))));
};
export default SvgUsd;